import { Navigate } from "react-router-dom";
import useAuth from "src/hooks/useAuth";
import { PATH_DASHBOARD, PATH_HUB } from "src/routes/paths";
import LoadingScreen from "./LoadingScreen";

const SmartRedirect = () => {
  const { isAuthenticated, isInitialized, isAdmin, isSubAdmin } = useAuth();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  // Admin/SubAdmin go to Network dashboard
  if (isAdmin || isSubAdmin) {
    return <Navigate to={PATH_DASHBOARD.root} replace />;
  }

  // Regular users go to hub
  return <Navigate to={PATH_HUB.root} replace />;
};

export default SmartRedirect;
